import { Text } from '@react-pdf/renderer'
import { dateFormat } from 'app/appSettings'
import { ImprovedHtml } from 'app/views/common-components/ImprovedHtml'
import moment from 'moment'
import { pdfDefaultFontSize } from '../../pdf-components/PDFCommon'

export const FormTextInputPdf = ({
  value,
  elementType,
  typeProps,
  langVersion,
  ...props
}) => {
  const { currency, isAdvancedTextEditor, defaultValue } = typeProps
  let valueToShow = value || defaultValue || ''

  if (elementType === 'textInputNumeric' && valueToShow) {
    if (currency && !(isNaN(value) || Boolean(!value && value !== 0))) {
      valueToShow = String(
        langVersion !== 'fr'
          ? new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: 'CAD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(value)
          : new Intl.NumberFormat('fr-CA', {
            style: 'currency',
            currency: 'CAD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          })
            .format(value)
            .split('CA')[0]
      )
    }
  } else if (elementType === 'datePicker' && valueToShow) {
    valueToShow = moment(valueToShow).format(dateFormat)
  } else if (isAdvancedTextEditor || /<\/?[a-z][\s\S]*>/i.test(valueToShow)) {
    valueToShow = valueToShow
      .replace(/<figure class="table">/g, '')
      .replace(/<\/figure>/g, '')
    return (
      <ImprovedHtml style={{ fontSize: pdfDefaultFontSize }}>
        {valueToShow}
      </ImprovedHtml>
    )
  }

  return (
    <Text style={{ whiteSpace: 'pre-line', fontSize: pdfDefaultFontSize }}>
      {valueToShow}
    </Text>
  )
}
